import useSWR from "swr";
import type { SwrReturnType } from "~/models/Api";
import type { VendorManagementCompanySetting } from "~/models/VendorManagementCompanySetting";

const paths = {
	show: "/vendors/vendor_management_company_settings/:company_master_id"
};
type TShow = (
	companyMasterId: number
) => SwrReturnType<VendorManagementCompanySetting>;
type ReturnType = {
	show: TShow;
};

export const useVendorManagementCompanySettings = (): ReturnType => {
	const show: TShow = (companyMasterId: number) => {
		const { data, mutate, error, isLoading } =
			// eslint-disable-next-line react-hooks/rules-of-hooks
			useSWR<VendorManagementCompanySetting>(
				paths.show.replace(":company_master_id", String(companyMasterId))
			);
		return {
			data: data ?? null,
			error,
			isLoading,
			mutate: mutate ?? null
		};
	};
	return { show };
};
